import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter/components/AdvancedFilterRow';
import { useFilterChangeCallback, useSelectorWithConfig } from 'shared/hooks';
import { selectOnlineBookingFilter } from 'shared/selectors/advancedFilters';

export const OnlineBookingContainer: FC = () => {
  const { label, value, visible } = useSelectorWithConfig(selectOnlineBookingFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setOnlineBooking', arguments: [newValue || null] });
    },
    [onChange],
  );

  if (!visible) {
    return null;
  }

  return (
    <AdvancedFilterRow label={label}>
      <Checkbox label="Мгновенное бронирование" checked={value} onChange={handleChange} />
    </AdvancedFilterRow>
  );
};
